<script>
  import { countryStore } from "../store/countries.js";
  export let countryId;
</script>

{#if countryId && countryId > 0}
  {#await countryStore.getCountry(countryId) then country}
    {country && country.nameKey}
  {/await}
{/if}
